// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searching-input-container {
    display: flex;
    flex-direction: row;
    height: 3rem;
}

.searching-input-container__btn-search {
    background: none;
    border-bottom: 1px #9e9e9e solid;
    color: black;
    width: 3rem;
    height: 3rem;
    box-shadow: none;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-left: 0 !important;
}

.searching-input-container__btn-search:hover {
    box-shadow: none;
    margin-left: 0 !important;
    color: #fff;
}

.searching-input-container__input {
    height: calc(3rem - 1px) !important;
    margin: 0 !important;
    margin-right: 0 !important;
}

.searching-input-container__input:hover {
    box-shadow: none !important;
    margin-right: 0 !important;
}

.searching-input-container__input:focus {
    box-shadow: none !important;
    margin-right: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/searching-input/SearchingInput.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B","sourcesContent":[".searching-input-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: 3rem;\r\n}\r\n\r\n.searching-input-container__btn-search {\r\n    background: none;\r\n    border-bottom: 1px #9e9e9e solid;\r\n    color: black;\r\n    width: 3rem;\r\n    height: 3rem;\r\n    box-shadow: none;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-content: center;\r\n    margin-left: 0 !important;\r\n}\r\n\r\n.searching-input-container__btn-search:hover {\r\n    box-shadow: none;\r\n    margin-left: 0 !important;\r\n    color: #fff;\r\n}\r\n\r\n.searching-input-container__input {\r\n    height: calc(3rem - 1px) !important;\r\n    margin: 0 !important;\r\n    margin-right: 0 !important;\r\n}\r\n\r\n.searching-input-container__input:hover {\r\n    box-shadow: none !important;\r\n    margin-right: 0 !important;\r\n}\r\n\r\n.searching-input-container__input:focus {\r\n    box-shadow: none !important;\r\n    margin-right: 0 !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
